import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  editButton: {
    border: "none !important",
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  topBlock: {
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        flex: 1,
      },
      "& .left": {
        paddingRight: "10px",
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: `0 ${theme.spacing(2)}px`,
      },
      "& .label": {
        color: "#2D2D2D",
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: "#030F85",
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
    },
  },
}));
